import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect } from "react";
import { useState } from "react";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { InputText } from "primereact/inputtext";

const CotizacionesTable = ({
  cotizaciones,
  loading,
  actionBodyTemplate,
  handleRowClick,
}) => {
  const rowClassName = (rowData) => {
    return {
      "cursor-pointer": true,
    };
  };
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [filters, setFilters] = useState(null);
  useEffect(() => {
    initFilters();
  }, []);
  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      nombre_producto: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    });
    setGlobalFilterValue("");
  };
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const renderHeader = () => {
    return (
      <>
        <div className="flex justify-content-between">
          <span className="p-input-icon-left" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            <i className="pi pi-search" />
            <InputText
              value={globalFilterValue ? globalFilterValue.toUpperCase() : ""}
              onChange={(e) => onGlobalFilterChange(e)}
              placeholder="Buscar por Cliente..."
            />
          </span>
        </div>
        <div className="flex justify-content-end mt-2">
          <span className="p-input-icon-left ml-2" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            {cotizaciones?.length} borradores
          </span>
        </div>
      </>
    );
  };
  const header = renderHeader();
  return (
    <div className="col-12">
      <DataTable
        value={cotizaciones}
        paginator
        className="p-datatable-gridlines"
        showGridlines
        rows={10}
        rowsPerPageOptions={[10, 20, 50, 100]}
        dataKey="id"
        filters={filters}
        filterDisplay="menu"
        loading={loading}
        emptyMessage="No se encontraron borradores."
        stripedRows="true"
        onRowClick={(e) => !loading && handleRowClick(e.data)}
        rowClassName={rowClassName}
        globalFilterFields={["cliente.razonSocial"]}
        header={header}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} borradores"
        scrollHeight="57vh"
        scrollable
      >
        <Column
          field="id"
          header="Borrador"
          filterMenuStyle={{ width: "2rem" }}
          style={{ minWidth: "7rem" }}
          body={(rowData) => (
            <span>
              {rowData.folio ? (
                <><strong>Folio</strong> {rowData.folio} <br/>
                <strong>ID</strong> {rowData.id}</>
              ) : (
                <><strong>ID</strong> {rowData.id}</>
              )}
            </span>
          )}
          sortable
        />
        <Column
          field="cliente.razonSocial"
          header="Cliente"
          filterMenuStyle={{ width: "14rem" }}
          style={{ minWidth: "7rem" }}
          body={(rowData) => rowData.cliente.razonSocial}
          sortable
        />
        <Column
          field="fecha_creacion_cotizacion"
          header="Fecha de Creación"
          sortable
          body={(rowData) => {
            if (rowData.fecha_creacion_cotizacion) {
              let date;
              if (typeof rowData.fecha_creacion_cotizacion === 'string') {
                const parts = rowData.fecha_creacion_cotizacion.split(' ');
                if (parts.length === 6) {
                  // Drop weekday and timezone, rebuild in a parsable format
                  const [, month, day, time, , year] = parts;
                  date = new Date(`${month} ${day} ${year} ${time} GMT-0400`);
                } else {
                  date = new Date(rowData.fecha_creacion_cotizacion);
                }
              } else {
                date = new Date(rowData.fecha_creacion_cotizacion);
              }
              if (isNaN(date)) {
                return "Fecha inválida";
              }
              return date.toLocaleDateString('es-CL', {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
              }).replace(/-/g, '/');
            }
            return "No tiene fecha";
          }}
        />
        <Column
          field="desde"
          header="Desde"
          body={(rowData) => {
            return rowData.desde ? rowData.desde : "No tiene fecha";
          }}
          sortable
        />
        <Column
          field="hasta"
          header="Hasta"
          body={(rowData) => {
            return rowData.hasta ? rowData.hasta : "No tiene fecha";
          }}
          sortable
        />

        <Column
          field="empresa"
          header="Empresa"
          filterMenuStyle={{ width: "14rem" }}
          style={{ minWidth: "7rem" }}
          body={(rowData) => rowData.empresa}
          sortable
        />

        <Column
          field="creadorNombre"
          header="Responsable"
          style={{ minWidth: "7rem" }}
          body={(rowData) => rowData.creadorNombre}
          sortable
          sortField="creadorNombre"
        />

        <Column
          header="Acciones"
          body={actionBodyTemplate}
          style={{ minWidth: "7rem", textAlign: "center" }}
        />
      </DataTable>
    </div>
  );
};

export default CotizacionesTable;
